export default __webpack_public_path__ + "static/media/ecosystem-members-link-img4.2d54c11e.png";